export default __webpack_public_path__ + "static/media/copy-icon.6349603d.svg";